/**
 * Inset of the hover action buttons from the top edge of the image, matching their inset from the sides
 * (`left-1` / `right-1`), per the asset tile spec. The slot badge in `asset.image.tsx` sits at the same inset
 * (`top-1 left-1`) so it lines up with the actions.
 */
const BUTTON_TOP_INSET = 2;

/**
 * `Asset.Label` renders a single `text-xs` line box above the image, whose line height is 16px.
 */
const LABEL_HEIGHT = 16;

/**
 * Hover-action top offset for a tile with an `Asset.Label`: the buttons are positioned against the tile root, which
 * starts at the label, so they clear it to keep the standard inset from the image. `Asset` applies this itself; pass
 * it as `buttonTopOffset` only where the tile can't see its label (the drag handle of `AssetDraggableWithHandle`).
 */
const LABELED_BUTTON_TOP_OFFSET = LABEL_HEIGHT + BUTTON_TOP_INSET;

export { BUTTON_TOP_INSET, LABELED_BUTTON_TOP_OFFSET };
